import { AxiosResponse } from "axios";
import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";
import { LinkedUserToClientPanelInstructionBase } from "./model";
import UserWithAvatar from "components/Atoms/UserWithAvatar";

interface Props<T extends LinkedUserToClientPanelInstructionBase> extends MultiPickerListProps<server.dto.UserToClientSmall> {
  initialInstruction: T;
  listFunc: (instruction: T) => Promise<AxiosResponse<server.dto.ApiResponseWrapperWithRequest<server.dto.UserToClientSmall[], server.dto.ListLinkedUserToClientFilters>, any>>;
}

const MultiLinkedUserToClientList = <T extends LinkedUserToClientPanelInstructionBase>(props: Props<T>) => {
  const [instruction, setInstruction] = React.useState<T>({
    page: 1,
    perPage: 20,
    keyword: undefined,
    ...props.initialInstruction,
  });

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="linkedusertoclientpickerlist"
      api={props.listFunc}

      getError={() => undefined}
      excludeKeys={props.excludeKeys}

      onChange={props.onChange}
      renderListItem={userToClient => <UserWithAvatar user={userToClient.user} avatarSize="avatar" />}
      getId={u => u.user.userId}
      getLabel={userToClient => userToClient.user.fullName}
      value={props.value}
    />
  </>;
};

export default MultiLinkedUserToClientList;